import { ColumnLabel } from "@components/Table/Settings/Toolbar";
import { createBranch, editBranch, getBranch, inactivateBranch } from "@services/form";
import { IBranchResponse } from "@types";
import { useT } from "@hooks";
import SettingsCrudPage from "../SettingsCrudPage";
import SettingsNameDialogs from "../SettingsNameDialogs";
import useSettingsCrudPage from "../useSettingsCrudPage";

const defaultColumnOrder = ["name"];

const BranchesPage = () => {
  const t = useT();

  const crud = useSettingsCrudPage({
    translationPrefix: "settings.branch",
    fetchService: getBranch,
    mountOption: (data: IBranchResponse[]) =>
      data?.map((res) => ({
        id: res.id,
        name: res.name,
        date: "",
        active: res?.active,
      })),
    createService: (value) => createBranch({ name: value }),
    editService: (selected, value) => editBranch({ id: selected.id, name: value }),
    inactivateService: inactivateBranch,
  });

  const columnLabels: ColumnLabel = {
    id: "1",
    name: t("settings.branch.column.name"),
    date: "",
  };

  return (
    <SettingsCrudPage
      crud={crud}
      translationPrefix="settings.branch"
      columnLabels={columnLabels}
      defaultColumnOrder={defaultColumnOrder}
    >
      <SettingsNameDialogs
        crud={crud}
        newTitle={t("settings.branch.dialog.newTitle")}
        editTitle={t("settings.branch.dialog.editTitle")}
        newPlaceholder={t("settings.branch.placeholder.name")}
        editPlaceholder={t("settings.branch.placeholder.name")}
        resetDuplicateAlert
      />
    </SettingsCrudPage>
  );
};

export default BranchesPage;
